import React from "react";
import PaginationButton from "../PaginationButton/PaginationButton";
import styles from "./styles.module.scss";

interface Props {
  count: number;
  onClick: (page: number) => void;
  activePage: number;
  onClickNext: () => void;
  onClickPrev: () => void;
}

const Pagination: React.FC<Props> = ({
  count,
  onClick,
  activePage,
  onClickNext,
  onClickPrev,
}) => {
  // Функція для генерації списку сторінок
  const generatePages = () => {
    const pages: (number | string)[] = [];
    const maxVisiblePages = 5; // Кількість сторінок навколо активної
    const start = Math.max(2, activePage - 2);
    const end = Math.min(count - 1, activePage + 2);

    // Завжди показувати першу сторінку
    pages.push(1);

    // Додаємо "..." перед активним блоком, якщо це необхідно
    if (start > 2) {
      pages.push("...");
    }

    // Додаємо сторінки в межах діапазону
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Додаємо "..." після активного блоку, якщо це необхідно
    if (end < count - 1) {
      pages.push("...");
    }

    // Завжди показувати останню сторінку
    if (count > 1) {
      pages.push(count);
    }

    return pages;
  };

  const pages = generatePages();

  return (
    <>
      {count !== 0 && (
        <div className={styles.container}>
          <button
            onClick={onClickPrev}
            className={styles.button}
            disabled={activePage === 1}
          >
            Previous
          </button>
          <div className={styles.countContainer}>
            {pages.map((page, index) =>
              typeof page === "number" ? (
                <PaginationButton
                  key={page}
                  page={page}
                  isActive={page === activePage}
                  onClick={onClick}
                />
              ) : (
                <span key={`ellipsis-${index}`} className={styles.ellipsis}>
                  {page}
                </span>
              )
            )}
          </div>
          <button
            onClick={onClickNext}
            className={styles.button}
            disabled={activePage === count}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default Pagination;
